import { ButtonPresentationProps } from "@insite/mobius/Button";
import { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import { colorPalette, colorStrings, fontFamily } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const buttonCommon: ButtonPresentationProps = {
    shape: "rectangle",
    activeMode: "lighten",
    hoverMode: "lighten",
    sizeVariant: "medium",
    typographyProps: {
        weight: 500,
        fontFamily,
    },
    css: css`
        &&& {
            position: relative;
        }
    `,
    mergeCss: true,
};

export const button: {
    defaultProps?: ButtonPresentationProps;
    primary: ButtonPresentationProps;
    secondary: ButtonPresentationProps;
    tertiary: ButtonPresentationProps;
} = {
    primary: {
        ...buttonCommon,
        color: colorStrings.secondaryMain,
    } as ButtonPresentationProps,
    secondary: {
        ...buttonCommon,
        color: colorStrings.secondaryMain,
        buttonType: "outline",
        css: css`
            background: ${colorPalette.common.global.white};
        `,
    } as ButtonPresentationProps,
    tertiary: {
        ...buttonCommon,
        color: colorStrings.commonGlobalWhite,
        buttonType: "outline",
    } as ButtonPresentationProps,
};

export const overflowMenu: {
    defaultProps?: OverflowMenuPresentationProps;
} = {
    defaultProps: {
        mergeCss: true,
        iconProps: {
            color: colorStrings.commonGlobalGuardianBlue,
        },
        buttonProps: {
            shape: "rectangle",
            hoverMode: "none",
        },
    },
};
